import React, { useEffect } from "react";
import Header from "./Header";
import SingleSignOnSideBar from "./SingleSignOnSideBar";
function MainPage(props) {
  const storeToken = localStorage.getItem("ssoToken");
  if (storeToken == null) {
    window.location.replace("/");
    // localStorage.clear("");
  }
  const project = JSON.parse(localStorage.getItem("project"));
  return (
    <>
      <Header   portal={"TELECALLER"}/>
      <SingleSignOnSideBar />
    </>
  );
}
export default MainPage;
